import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Action,
  Mutation,
} from "vuex-module-decorators";
import store from "@/store";
import { RequestsService } from "@/services/api/request.service";
import { RequestC } from "~/modules/request";
import { RequestData } from "~/request.data";
import { SaveRequestDTO } from "~/save.request.dto";
import { AccountInfo } from "~/account.info";
import { AccountInfoDTO } from "~/account.info.dto";
import { Attachment } from "~/attanchment";
import { SaveFileDTO } from "~/save.file.dto";
@Module({
  dynamic: true,
  store,
  name: "requests",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class RequestsVuexModule extends VuexModule {
  list: RequestC[] = [];
  reqDetailList: RequestData[] = [];
  accountInfo: AccountInfo = null as any;
  listAttachment: Attachment[] = [];

  @Mutation
  public async setListAttachment(val: Attachment[]) {
    this.listAttachment = val;
  }

  @Mutation
  public async setAccInfo() {
    this.accountInfo = null as any;
  }

  @Mutation
  public async setlistAttachment() {
    this.listAttachment = [];
  }

  @MutationAction
  public async getAccountDebtInfo(req: AccountInfoDTO) {
    const accountInfo = await RequestsService.getAccountDebtInfo(req);
    return { accountInfo };
  }

  @MutationAction
  public async getRequestList() {
    const list = await RequestsService.getRequestList();
    return { list };
  }

  @MutationAction
  public async getData(RID: number) {
    const reqDetailList = await RequestsService.getData(RID);
    return { reqDetailList };
  }

  @MutationAction
  public async getAttachments(RID: number) {
    const listAttachment = await RequestsService.getAttachments(RID);
    listAttachment.forEach((element: Attachment) => {
      element.isError = null as any;
      element.loading = false;
      element.loading2 = false;
    });
    return { listAttachment };
  }

  @Action
  public async saveData(req: SaveRequestDTO) {
    return await RequestsService.saveData(req);
  }

  @Action
  public async getFile(attach_id: number) {
    return await RequestsService.getFile(attach_id);
  }

  @Action
  public async deleteAttachment(attach_id: number) {
    return await RequestsService.deleteFile(attach_id);
  }

  @Action
  public async uploadFile(req: SaveFileDTO) {
    await RequestsService.uploadFile(req);
  }

  @Mutation
  public async setError(req: any) {
    const { attatchment_type_rid, err } = req;
    const res = this.listAttachment.find(
      x => x.attatchment_type_rid == attatchment_type_rid,
    );
    if (res) res.isError = err;
  }

  @Action
  public async checkNumberIIN(IIN: string) {
    return await RequestsService.checkNumberIIN(IIN);
  }

  @Action
  public async deleteRequest(RID: number) {
    return await RequestsService.deleteRequest(RID);
  }

  @Action
  public async signAndSend(req: any) {
    const { RID, data } = req;
    return await RequestsService.signAndSend(RID, data);
  }

  @Action
  public async downloadPDF(reqNumber: number) {
    return await RequestsService.downloadPDF(reqNumber);
  }
}

export const RequestsModule = getModule(RequestsVuexModule);
